import { NewRelicBrowserAgentOptions, NewRelicBrowserConfig } from "./types";

export const buildNewRelicOptions = (config: NewRelicBrowserConfig): NewRelicBrowserAgentOptions => {
  return {
    info: {
      applicationID: config.applicationId,
      beacon: config.beacon,
      errorBeacon: config.beacon,
      licenseKey: config.licenseKey,
      sa: 1
    },
    init: {
      ajax: {
        deny_list: [config.beacon]
      },
      browser_consent_mode: {
        enabled: false
      },
      distributed_tracing: {
        enabled: true
      },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true
      },
      privacy: {
        cookies_enabled: true
      }
    },
    loader_config: {
      accountID: config.accountId,
      agentID: config.agentId,
      applicationID: config.applicationId,
      licenseKey: config.licenseKey,
      trustKey: config.trustKey
    }
  };
};
